import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContextSelector as useCS } from 'use-context-selector';
import { Modal } from '@mui/material';
import { CloseIcon, JobPostIsLiveModalIcon } from 'assets';
import { TUpdate } from 'domain/types';
import { Button } from 'view/components';
import * as CS from 'view/modals/styled';
import {
  CreateJobPostConfigContext,
  TCreateJobPostContextState,
} from 'domain/createJobPostConfig/CreateJobPostContext';
import { createJobPostConfigSelectors } from 'domain/createJobPostConfig/selectors';
import { storageService } from 'infrastructure/services/StorageService';

const CreateJobPostAfterSubmitModal: FC<{ hideCloseButton?: boolean }> = ({
  hideCloseButton = false,
}) => {
  const navigate = useNavigate();
  const isOpenAfterSubmitJobPostModal: boolean = useCS(
    CreateJobPostConfigContext,
    createJobPostConfigSelectors.isOpenAfterSubmitJobPostModal
  );
  const update: TUpdate<TCreateJobPostContextState> | undefined = useCS(
    CreateJobPostConfigContext,
    createJobPostConfigSelectors.update
  );

  const onClose = () => {
    if (update) update({ isOpenAfterSubmitJobPostModal: false });
  };

  return (
    <Modal
      open={isOpenAfterSubmitJobPostModal}
      onClose={() => {}}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <CS.ModalMainWrapper>
        {!hideCloseButton ? (
          <CS.CloseIconBox onClick={onClose}>
            <CloseIcon />
          </CS.CloseIconBox>
        ) : null}
        <CS.ModalMainBox>
          <CS.ModalMainImage>
            <JobPostIsLiveModalIcon />
          </CS.ModalMainImage>
          <CS.ModalMainHeader>
            <CS.ModalMainHeaderTitle>🎉 Your Job Post is Live!</CS.ModalMainHeaderTitle>
            <CS.ModalMainHeaderSubTitle>
              {'Great job! Your posting is now active \n and open for applications.'}
            </CS.ModalMainHeaderSubTitle>
          </CS.ModalMainHeader>
        </CS.ModalMainBox>
        <CS.ModalMainFooter>
          <Button
            variant="outlined"
            text="Go to home"
            onClick={() => {
              if (update)
                update({
                  isOpenAfterSubmitJobPostModal: false,
                  createJobPostData: null,
                  screeningQuestions: [],
                });
              storageService.removeItem('createJobPostId');
              navigate('/candidates/my-job-posts?postStatus=active', { replace: true });
            }}
            disabled={false}
            style={{ width: '100%', minHeight: '50px' }}
          />
          <Button
            variant="contained"
            text="View Job Post"
            onClick={() => {
              if (update) update({ isOpenAfterSubmitJobPostModal: false });
              navigate('/profile/job-post-preview', { replace: true });
            }}
          />
        </CS.ModalMainFooter>
      </CS.ModalMainWrapper>
    </Modal>
  );
};

export default CreateJobPostAfterSubmitModal;
